import React, { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppLoading } from '../../loaders/loaders.js';
import { withStyles } from '@material-ui/core';
import { withUserProfile } from '../../userProfile/userProfileContext.js';
import { compose } from 'recompose';
import styles from './styles.js';
const ShowPickupInfoPopup = lazy(() => import('../modules/Common/ShowPickupInfoPopup.js'));
const ShowGroupPickupInfoPopup = lazy(() => import('../modules/Common/ShowGroupPickupInfoPopup'));
const ShowDeliveryProDetailsPopup = lazy(() =>
  import('../modules/Common/ProDetailsPopup/ShowDeliveryProDetailsPopup.js')
);
const ShowPickupProDetailsPopup = lazy(() =>
  import('../modules/Common/ProDetailsPopup/ShowPickupProDetailsPopup.js')
);
const AddProToPlan = lazy(() => import('../modules/Common/AddProToPlan/index.js'));
import InAppTutorial from '../InAppTutorial/InAppTutorialDialog.js';
import { PageNavigator } from '../../routes/PageNavigator.js';
import { getQueryParams } from './utils.js';

const GlobalRouteComponents = ({ classes, userData }) => {
  const [searchParams] = useSearchParams();
  const hasTerminalCode = userData?.userProfile?.terminal?.code;
  let pickupNumber, groupId, isPickupPro, proId, proMode, ProDetailsPopupComponent;
  if (hasTerminalCode) {
    const fields = ['proId', 'isPickupPro', 'pickupNumber', 'proMode', 'groupId'];
    ({ pickupNumber, groupId, isPickupPro, proId, proMode } = getQueryParams(searchParams, fields));
    ProDetailsPopupComponent = isPickupPro
      ? ShowPickupProDetailsPopup
      : ShowDeliveryProDetailsPopup;
  }

  let pickupDetailsPopup = null;
  if (pickupNumber) {
    pickupDetailsPopup = <ShowPickupInfoPopup pickupNumber={pickupNumber} />;
  } else if (groupId) {
    pickupDetailsPopup = <ShowGroupPickupInfoPopup groupId={groupId} />;
  }

  return (
    <>
      <PageNavigator />
      {hasTerminalCode && (
        <>
          <InAppTutorial />
          <Suspense fallback={<AppLoading />}>
            {pickupDetailsPopup}
            {proId && <ProDetailsPopupComponent proId={proId} pickupNumber={pickupNumber} />}
            {proMode && (
              <AddProToPlan
                open={Boolean(proMode)}
                proMode={proMode}
                key={proMode}
                drawerClasses={{
                  paper: classes.addProPaperAnchor
                }}
                variant="persistent"
              />
            )}
          </Suspense>
        </>
      )}
    </>
  );
};

export default compose(withStyles(styles), withUserProfile)(GlobalRouteComponents);
